import moment from "moment-timezone";

export const MOBILE_HEADER_WIDTH = 820;
export const MOBILE_CALENDAR_WIDTH = 1366;

/** Высота шапки страницы расписания (месяц + «+» + отступы), чтобы колонки опирались на viewport, не на navbar. */
const SCHEDULE_PAGE_CHROME = 90;

export function getScheduleCalendarMinHeight(screenWidth, screenHeight) {
  const paddingTop = screenWidth >= 1366 && screenWidth < 1420 ? 25 : 68;
  const paddingBottom = screenWidth >= 1280 && screenWidth < 1400 ? 10 : 25;
  return Math.max(
    360,
    screenHeight - paddingTop - paddingBottom - SCHEDULE_PAGE_CHROME,
  );
}

export const isTodayInTimeZone = (day, timeZone) =>
  moment(day).tz(timeZone).isSame(moment().tz(timeZone), "day");

export function getLessonWordEnding(quantity) {
  const lastDigit = quantity % 10;
  const lastTwoDigits = quantity % 100;
  if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
    return "ий";
  }
  if (lastDigit === 1) {
    return "ие";
  }
  if (lastDigit >= 2 && lastDigit <= 4) {
    return "ия";
  }
  return "ий";
}

export function getWeekRangeForDate(date) {
  return [moment(date).startOf("isoWeek"), moment(date).endOf("isoWeek")];
}

export function getNormalizedWeekDayMonFirst(weekDay) {
  if (weekDay === 0) return 6;
  return weekDay - 1;
}

export function getNormalizedWeekDaySunLast(weekDay) {
  if (weekDay === 0) return 7;
  return weekDay;
}
